__turbopack_context__.v({
  "attachment": "GQpiVG_attachment",
  "container": "GQpiVG_container",
  "lineItemSummary": "GQpiVG_lineItemSummary",
  "notes": "GQpiVG_notes",
});
